//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.ParamBuilder.js";
import "../no/SectionList.js";
import "../CAM/CAM.DmStreamlineCutStep.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../CAM/CAM.StepoverBuilder.js";
import "../CAM/CAM.DmToolPosition.js";
import "../CAM/CAM.DmTrimExtend.js";
import "../no/ObjectList.js";
let d=[[[0,"CrossCurveCount",1,0],[1,"CrossCurveList",0,"SectionList",0],[0,"CrossCurveNormalToFlowCount",1,0],[0,"CrossCurveNormalToFlowSide",1,0],[0,"CrossCurvesMethod",1,0],[0,"CutPatternBuilder",0,"CAM.CutPatternBuilder",0],[1,"CutStepBuilder",0,"CAM.DmStreamlineCutStep",0],[0,"CutStepFirstCut",1,1],[0,"CutStepSecondCut",1,1],[0,"CutStepThirdCut",1,1],[0,"CutType",1,0],[0,"FlowCurveCount",1,0],[1,"FlowCurveList",0,"SectionList",0],[0,"PreviewEnabled",1,0],[0,"SelectionMethod",1,0],[1,"StepIntol",0,"CAM.InheritableDoubleBuilder",1],[0,"StepMethod",1,1],[1,"StepOuttol",0,"CAM.InheritableDoubleBuilder",1],[1,"StepoverBuilder",0,"CAM.StepoverBuilder",0],[0,"StepoverDis",1,0],[0,"StepoverNum",1,0],[0,"StepoverScallopHeight",1,0],[0,"StepoverType",1,0],[0,"ToolPosition",1,1],[1,"ToolPositionBuilder",0,"CAM.DmToolPosition",0],[1,"TrimExtendBuilder",0,"CAM.DmTrimExtend",0],[0,"UsePartNormal",1,0]],[[["count"],"GetExtendValues",{R_:{values:""}},0,1],[["values"],"SetExtendValues",{},1,1],[[],"MPreview",{},0,0],[[],"FlipMaterial",{},0,0],[["count","curves"],"GetCrossCurveNormalToFlowCurve",{},0,0],[["curves"],"SetCrossCurveNormalToFlowCurve",{},1,0]],[]];
SPLM.CAM.DPMItpBuilder = class extends SPLM.CAM.ParamBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.DPMItpBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.DPMItpBuilder.SelectionMethodOption = Object.freeze({
    "Automatic" : "Automatic", "Specify" : "Specify", "OnPart" : "OnPart"});

SPLM.CAM.DPMItpBuilder.ToolPositionOption = Object.freeze({
    "On" : "On", "Tanto" : "Tanto", "Contact" : "Contact"});

SPLM.CAM.DPMItpBuilder.CutTypeOption = Object.freeze({
    "Zig" : "Zig", "Zigzag" : "Zigzag", "ZigzagWithLifts" : "ZigzagWithLifts", "SpiralHelix" : "SpiralHelix"});

SPLM.CAM.DPMItpBuilder.StepMethodOption = Object.freeze({
    "Tolerance" : "Tolerance", "Points" : "Points"});

SPLM.CAM.DPMItpBuilder.StepoverTypeOption = Object.freeze({
    "Number" : "Number", "Distance" : "Distance", "Scallop" : "Scallop"});

SPLM.CAM.DPMItpBuilder.CrossCurvesMethodOption = Object.freeze({
    "OnPart" : "OnPart", "NormalToFlow" : "NormalToFlow"});

SPLM.CAM.DPMItpBuilder.CrossCurveNormalToFlowSideOption = Object.freeze({
    "Both" : "Both", "Left" : "Left", "Right" : "Right"});

export default SPLM;